var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"layout-authorized--mobile",class:{
    'layout-authorized--has-confirm-banner': !_vm.hasConfirmedEmail && !_vm.isIosWebView,
    'layout-authorized--has-tabbar': _vm.hasTabbar,
    'layout-authorized--ios': _vm.isIosWebView,
    'layout-authorized--overlay': _vm.showOverlay,
  }},[(!_vm.hasConfirmedEmail && !_vm.isIosWebView)?_c('confirm-email-banner'):_vm._e(),_vm._v(" "),_c('nuxt')],1)}
var staticRenderFns = []

export { render, staticRenderFns }